/* eslint-disable no-console */

const getDate = () => {
  const now = new Date();
  const date = (now.getDate() < 10 ? '0' : '') + now.getDate();
  const month = ((now.getMonth() + 1) < 10 ? '0' : '') + (now.getMonth() + 1);
  const year = now.getFullYear();
  const hours = (now.getHours() < 10 ? '0' : '') + now.getHours();
  const minutes = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
  const seconds = (now.getSeconds() < 10 ? '0' : '') + now.getSeconds();
  const milliseconds = (now.getMilliseconds() < 10 ? '00' : (now.getMilliseconds() < 100 ? '0' : '')) + now.getMilliseconds(); // eslint-disable-line
  return `${date}.${month}.${year} ${hours}:${minutes}:${seconds}.${milliseconds}`;
};

const trace = (value) => {
  console.log(`%c[UMWM] ${getDate()} - ${value}`, 'color: #a3a6af');
};

const debug = (value, object) => {
  console.log(`[UMWM] ${getDate()} - ${value}`);
  if (object) {
    console.log(object);
  }
};

const info = (value) => {
  console.info(`[UMWM] ${getDate()} - ${value}`);
};

const warn = (value) => {
  console.warn(`[UMWM] ${getDate()} - ${value}`);
};

const error = (value) => {
  console.error(`[UMWM] ${getDate()} - ${value}`);
};

const fatal = (value) => {
  console.error(`[UMWM] ${getDate()} - ${value}`);
};

export default {
  trace,
  debug,
  info,
  warn,
  error,
  fatal,
};

/* eslint-enable no-console */
